exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-modal-button[data-v-8f6e7520]{border:1px solid #d1d5db;border-radius:.375rem;padding:.55rem .9rem;font-size:.875rem;background:#fff;color:#374151}.delete-modal-button[data-v-8f6e7520]:hover{border-color:#2563eb;color:#2563eb}.delete-modal-danger[data-v-8f6e7520]{background:#b91c1c;border-color:#b91c1c;color:#fff}.delete-modal-danger[data-v-8f6e7520]:hover{background:#991b1b;border-color:#991b1b;color:#fff}", ""]);

// exports
